// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_LOADED() {
      return {
        isLoading: false,
        data: action.company
      };
    },
    COMPANY_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.company.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
